module.exports = __webpack_public_path__ + "static/media/pull_img2.3a5932af.png";